import React, { useState, useEffect, Suspense } from 'react';
import { isMobile } from 'react-device-detect';
const LazyBottomMenu = () => {
  const [shouldLoad, setShouldLoad] = useState(false);
  useEffect(() => {
    if (!isMobile) return;
    const handleScroll = () => {
      if (window.scrollY > 100) {
        window.removeEventListener('scroll', handleScroll);
        setTimeout(() => setShouldLoad(true), 2000);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isMobile) return null;
  const BottomMenuComponent = React.lazy(() => import('./BottomMenu'));
  return shouldLoad ? (
    <Suspense fallback={null}>
      <BottomMenuComponent />
    </Suspense>
  ) : null;
};
export default LazyBottomMenu;